let view = null;

export default {
	namespace: 'template-education',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: EducationView } = await import(
			/* webpackChunkName: "education-view" */ '../../templates/EducationView'
		);
		view = new EducationView(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
